export default function (_payload, models, verb = "edited") {
  return {
    actor: `user-${models.user.id}`,
    verb: verb,
    object: `planbook-${models.planbook.id}`,
    to: [`planbook-edits:planbook-${models.planbook.id}`],
  }
}
